<template>
  <v-app>
    <Navbar />
    <v-main>
      <router-view style="height: 100%" />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  components: {
    Navbar,
  },
};
</script>

<style>
</style>
